import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, FormLabel, Grid } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../../../components/Common/Breadcrumb';
import LoadingDialog from "../../../../components/Common/LoadingDialog";
import Notification from '../../../../components/Common/Notification';
import CustomButton from "../../../../components/Form/CustomButton";
import CustomSelect from "../../../../components/Form/CustomSelect";
import CustomTextField from "../../../../components/Form/CustomTextField";
import RadioButtonGroup from "../../../../components/Form/RadioButtonGroup";
import Helpers from "../../../../helpers/helpers";
import { createCategory, getCategoryDetails, getGeneral, resetAttachmentState, resetCategoryState, updateCategory } from "../../../../store/actions";



const AddCategory = ({ type, title, formError, addCategory, editCategory, categoryDetails, attachment, categories }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { ID } = useParams();
    const fileInputRef = useRef();
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const defaultValues = {
        title: "",
        visibility: "1",
        show_in_navigation_menu: 0,
        metaTitle: "",
        metaDesc: "",
        metaKeyword: "",
        category_type: "top_level",
        parent: "",
    }

    const categoryTypeOptions = [
        { value: "top_level", label: "Top-level category" },
        { value: "subcategory", label: "Subcategory" },
    ]

    const hasSubcategories = Number(categoryDetails?.children_count || 0) > 0;

    const data = [
        { value: "1", label: "Published" },
        { value: "0", label: "Unpublished" },
    ]

    const showInNavigationMenuOptions = [
        { value: 1, label: "Yes" },
        { value: 0, label: "No" },
    ]
    const [loading, setIsLoading] = useState(false);
    const [values, setFormValues] = useState(defaultValues);
    const [showSEO, setShowSEO] = useState(false);
    const [profileImg, setProfileImg] = useState();
    const [width, setWidth] = useState(window.innerWidth);
    const [error, setError] = useState();
    const [parentSearch, setParentSearch] = useState("");

    useEffect(() => {
        dispatch(resetAttachmentState());
        dispatch(resetCategoryState());
        dispatch(getGeneral());
        if (type === "Edit" && ID) {
            dispatch(getCategoryDetails({ id: ID }));
        }

        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (formError?.length > 0) {
            setError(formError[0]);
            setIsLoading(false);
        }
    }, [formError])

    useEffect(() => {
        if (addCategory?.code === "success") {
            setNotification({
                open: true,
                msg: "Added Successfully",
                type: "success",
            })
            dispatch(getGeneral());
            navigate("/settings-product-categories")
        }
    }, [addCategory])

    useEffect(() => {
        if (editCategory?.code === "success") {
            setNotification({
                open: true,
                msg: "Edited Successfully",
                type: "success",
            })
            dispatch(getGeneral());
            setIsLoading(false);
        }
    }, [editCategory])

    useEffect(() => {
        if (categoryDetails?.category_descriptions) {
            setFormValues({
                title: categoryDetails?.category_descriptions?.name || '',
                visibility: categoryDetails?.status,
                metaTitle: categoryDetails?.category_descriptions?.page_title || '',
                metaDesc: categoryDetails?.category_descriptions?.meta_description || '',
                metaKeyword: categoryDetails?.category_descriptions?.meta_keyword || '',
                thumbnail_image: categoryDetails?.thumbnail_image || '',
                show_in_navigation_menu: categoryDetails?.show_in_navigation_menu || 0,
                sort_order: categoryDetails?.sort_order || 0,
                category_type: categoryDetails?.parent_id ? 'subcategory' : 'top_level',
                parent: categoryDetails?.parent_id || '',
            })
            setShowSEO(categoryDetails?.category_descriptions?.meta_keyword ? true : false);
        }
    }, [categoryDetails])

    const parentCategoryOptions = (categories || [])
        .filter((category) => !category.parent_id && String(category.id) !== String(ID))
        .map((category) => ({
            id: category.id,
            name: category.name,
        }));

    const filteredParentCategoryOptions = parentCategoryOptions.filter((category) =>
        (category.name || "").toLowerCase().includes(parentSearch.toLowerCase())
    );

    const handleSubmit = (type) => {
        if (values?.category_type === 'subcategory' && !values?.parent) {
            setError({ parent: 'Parent category is required for a subcategory.' });
            return;
        }

        let payload = {
            name: values?.title || '',
            status: values?.visibility,
            meta_title: values?.metaTitle || '',
            meta_keyword: values?.metaKeyword || '',
            meta_description: values?.metaDesc || '',
            thumbnail_image: values?.thumbnail_image || '',
            show_in_navigation_menu: Number(values?.show_in_navigation_menu || 0),
            sort_order: values?.sort_order,
            parent: values?.category_type === 'subcategory' ? values?.parent : null,
        }
        if (type === "Add") {
            dispatch(createCategory(payload));
        }
        else if (type === "Edit") {
            setIsLoading(true);
            dispatch(updateCategory({ id: ID, data: payload }));
        }

    }

    return (
        <React.Fragment>
            {
                width <= 425 &&
                <div className="mobile-button-container">
                    <CustomButton
                        title={type === 'Add' ? 'Save' : 'Save Changes'}
                        press={() => handleSubmit(type)}
                        height={40}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        width={'100%'}
                    />
                </div>
            }
            <div className="page-content">
                <Container fluid>
                    <LoadingDialog open={loading || (type === 'Edit' && !categoryDetails?.category_descriptions)} />
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumbs
                        backRoute={"/settings-product-categories"}
                        breadcrumbItems={[{ title: "Settings", link: "/settings" },
                        { title: 'Categories', link: "/settings-product-categories" },
                        { title: title, link: "#" },
                        ]}
                    >
                        {
                            width > 425 &&
                            <CustomButton
                                title={type === 'Add' ? 'Save' : 'Save Changes'}
                                press={() => handleSubmit(type)}
                                height={40}
                                backgroundColor={'#101010'}
                                textColor={'white'}
                            />
                        }
                    </Breadcrumbs>
                    {/* <Card className="p-3">
                        <CardBody> */}
                    <Grid container spacing={2}>
                        <Grid item sm={12} lg={8} pb={3}>
                            <Card className="p-3 px-2">
                                <CardBody>
                                    <div className="setting-header">BASIC INFO</div>
                                    <Divider className="my-2 mb-4" />
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <RadioButtonGroup
                                                title={<div style={{ fontFamily: 'Manrope-Semibold', color: '#00000099' }}>Category type</div>}
                                                value={values.category_type}
                                                data={categoryTypeOptions}
                                                setValue={(e) => {
                                                    if (hasSubcategories && e === 'subcategory') {
                                                        return;
                                                    }
                                                    setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        category_type: e,
                                                        parent: e === 'top_level' ? '' : prevValues.parent,
                                                    }));
                                                    if (e === 'top_level') {
                                                        setParentSearch("");
                                                    }
                                                }}
                                                required="true"
                                                name="category_type"
                                            />
                                        </Grid>
                                        {values?.category_type === 'subcategory' &&
                                            <Grid item xs={12} sm={12}>
                                                <CustomSelect
                                                    title={'Parent category'}
                                                    values={values?.parent || '-1'}
                                                    valueName={"id"}
                                                    labelName={"name"}
                                                    placeholder={"Select parent category"}
                                                    onChange={(e) => setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        parent: e,
                                                    }))}
                                                    searchable={true}
                                                    searchValue={parentSearch}
                                                    onSearchChange={(text) => setParentSearch(text)}
                                                    searchPlaceholder={"Type to filter parent categories"}
                                                    error={error && (!values?.parent || error?.parent) && (error?.parent || "The parent category field is required.")}
                                                    data={filteredParentCategoryOptions}
                                                />
                                                {parentSearch && filteredParentCategoryOptions.length === 0 && (
                                                    <FormHelperText style={{ color: "#74788DCC" }}>
                                                        No parent category matches "{parentSearch}".
                                                    </FormHelperText>
                                                )}
                                                <FormHelperText style={{ color: "#74788DCC" }}>
                                                    Subcategories are used for accessory groups such as Accessories › Dock.
                                                </FormHelperText>
                                                {hasSubcategories &&
                                                    <FormHelperText style={{ color: "#74788DCC" }}>
                                                        This category already has subcategories, so it must remain a top-level category.
                                                    </FormHelperText>
                                                }
                                            </Grid>
                                        }
                                        <Grid item xs={12} sm={12}>
                                            <CustomTextField
                                                title={values?.category_type === 'subcategory' ? 'Subcategory name' : 'Title'}
                                                values={values?.title}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    title: e
                                                }))}
                                                placeholder="Give this category a name"
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.name || ""}</FormHelperText>}
                                        </Grid>
                                    </Grid>
                                </CardBody>
                            </Card>

                            <Card className="p-3 px-2">
                                <CardBody>
                                    <div className="d-flex justify-content-between">
                                        <div className="setting-header">
                                            SEARCH ENGINE OPTIMIZATION
                                            <div className="setting-desc2">Add a name and description to see how this might appear in a search engine listing.</div>
                                        </div>
                                        <CustomButton
                                            title={`${showSEO ? 'Hide' : 'Edit'} website SEO`}
                                            press={() => setShowSEO(!showSEO)}
                                            textColor={"#7BB9FA"}
                                            backgroundColor={"transparent"}
                                        />
                                    </div>
                                    {
                                        showSEO &&
                                        <Grid container spacing={2} mt={2}>
                                            <Grid item xs={12} sm={12}>
                                                <CustomTextField
                                                    title={'Meta title'}
                                                    values={values?.metaTitle}
                                                    onChange={(e) => setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        metaTitle: e
                                                    }))}
                                                    placeholder="Headlines that appears in search entries"
                                                />
                                                {error && <FormHelperText sx={{ color: "red" }}>{error.metaTitle || ""}</FormHelperText>}
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <CustomTextField
                                                    title={'Meta keywords'}
                                                    values={values?.metaKeyword}
                                                    onChange={(e) => setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        metaKeyword: e
                                                    }))}
                                                    placeholder="Enter relevant keywords separated by commas"
                                                />
                                                {error && <FormHelperText sx={{ color: "red" }}>{error.metaKeyword || ""}</FormHelperText>}
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <CustomTextField
                                                    title={'Meta Description'}
                                                    values={values?.metaDesc}
                                                    onChange={(e) => setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        metaDesc: e
                                                    }))}
                                                    placeholder="Brief description that appears under the title in search entries"
                                                    multiline={true}
                                                    rows={4}
                                                />
                                                {error && <FormHelperText sx={{ color: "red" }}>{error.meta_description || ""}</FormHelperText>}
                                            </Grid>
                                        </Grid>
                                    }
                                </CardBody>
                            </Card>
                        </Grid>
                        <Grid container item sm={12} lg={type === 'add' ? 12 : 4}>
                            <Grid item xs={12} sm={12}>
                                <Card className="p-3 px-2">
                                    <CardBody>
                                        <div className="setting-header">SETTINGS</div>
                                        <Divider className="my-2 mb-4" />
                                        <CustomSelect
                                            title={"Display Icon"}
                                            valueName={"icon"}
                                            labelName={"label"}
                                            icon={true}
                                            values={values?.thumbnail_image || '-1'}
                                            onChange={(e) => setFormValues((prevValues) => ({
                                                ...prevValues,
                                                thumbnail_image: e
                                            }))}
                                            placeholder={'Select one'}
                                            data={Helpers?.icon || []}
                                        />
                                        <div className="mt-3">
                                            <RadioButtonGroup
                                                title={<>
                                                    <div style={{ fontFamily: 'Manrope-Semibold', color: '#00000099' }}>Show in Navigation Menu</div>
                                                    {/* <div className="setting-decs">Controls the category displayed in the navigation menu</div> */}
                                                </>}
                                                value={values.show_in_navigation_menu}
                                                data={showInNavigationMenuOptions}
                                                setValue={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    show_in_navigation_menu: e,
                                                }))}
                                                required="true"
                                                name="show_in_navigation_menu"
                                                error={error?.show_in_navigation_menu}
                                            />
                                            {/* {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>} */}
                                        </div>
                                        <div>
                                            <RadioButtonGroup
                                                title={<>
                                                    <div style={{ fontFamily: 'Manrope-Semibold', color: '#00000099' }}>Visibility</div>
                                                    <div className="setting-decs">This visibility only affect category in storefront</div>
                                                </>}
                                                value={values.visibility}
                                                data={data}
                                                setValue={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    visibility: e,
                                                }))}
                                                required="true"
                                                name="status"
                                                error={error?.status}
                                            />
                                            {/* {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>} */}
                                        </div>
                                        <div className="pb-3">
                                            <CustomTextField
                                                title={'Sort Order'}
                                                subtitleTop={'Larger number will appear first '}
                                                values={values?.sort_order}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    sort_order: e
                                                }))}
                                                placeholder="0"
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.sort_order || ""}</FormHelperText>}
                                        </div>
                                        {type === "Edit" &&
                                            <>
                                                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Last modified</FormLabel>
                                                <div>{moment(categoryDetails?.updated_at).format("DD MMM YYYY")}, {moment(categoryDetails?.updated_at).format("hh:mm A")}</div>
                                            </>}
                                    </CardBody>
                                </Card>

                            </Grid>
                        </Grid>
                    </Grid>
                    {/* </CardBody>
                    </Card> */}
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Category, General }) {
    return {
        formError: Category.error,
        addCategory: Category.addCategory,
        editCategory: Category.updateCategory,
        categoryDetails: Category.categoryDetails,
        attachment: General.attachment,
        categories: General.categories,
    };
}

export default connect(mapStateToProps)(AddCategory);
